import PortfolioOrDecisionNavigation from "@common/Components/PortfolioOrDecisionNavigation.vue";
import { ValidationError } from '@common/types';
import { ICommandStatus } from '@cqrs/cqrs';
import { ICriteriaCommand } from '@Criteria/cqrs';
import { CriterionSelectorDialogViewModel } from '@Criteria/Hierarchies/Components/CriterionSelectorDialog';
import CriterionSelectorDialog from '@Criteria/Hierarchies/Components/CriterionSelectorDialog.vue';
import { CriterionReadModel } from '@Criteria/Hierarchies/Domain/readmodels';
import { UpdateWeightedScoreCommandV1 } from '@Criteria/WeightedScores/Domain/commands-core';
import WeightedScoresCommands from "@Criteria/WeightedScores/Domain/commands-vue-component";
import WeightedScoresQueries from '@Criteria/WeightedScores/Domain/queries-vue-component';
import { WeightedScoreSettingsReadModel } from '@Criteria/WeightedScores/Domain/readmodels';
import { WeightsSetReadModel } from '@Criteria/Weights/Domain/readmodels';
import { Component, mixins } from 'vue-facing-decorator';


@Component({
    components: { PortfolioOrDecisionNavigation, CriterionSelectorDialog },
})
export default class EditWeightedScorePage extends mixins(WeightedScoresQueries, WeightedScoresCommands)
{
    get workspaceId(): number { return Number(this.$route?.params?.workspaceId ?? 0); }
    get projectId(): number { return Number(this.$route?.params?.projectId ?? 0); }

    criterionSelectorDialog = new CriterionSelectorDialogViewModel();

    rm: WeightedScoreSettingsReadModel | null = null;
    initialized: boolean = false;
    name: string | null = null;
    description: string | null = null;
    weightsSetId: number | null = null;
    criterionId: number | null = null;
    errors: ValidationError[] = [];
    isSaving: boolean = false;

    get evalModelId(): number { return this.rm.EvalModelId; }
    get weightedScoreId(): string { return this.rm.Id; }
    get attributeId(): number { return this.rm.AttributeId; }
    get criteria(): CriterionReadModel[] { return this.rm.Criteria ?? []; }
    get weightsSets(): WeightsSetReadModel[] { return this.rm.WeightsSets ?? []; }
    get goalCriterionId(): number { return this.criteria.find(c => c.ParentId == null).CriterionId; }
    get criterionLabel(): string | null
    {
        if (this.criterionId == null)
        {
            return this.criteria.find(a => a.ParentId == null)?.Name ?? null;
        }

        return this.criteria.find(a => a.CriterionId === this.criterionId)?.Name ?? null;
    }
    get nameError(): string | null { return this.errors.find(e => e.ErrorCode.startsWith("Name."))?.Error ?? null; }
    get hasChanges(): boolean
    {
        return this.name !== this.rm.Name ||
            this.description !== this.rm.Description ||
            this.criterionId !== this.rm.CriterionId ||
            this.weightsSetId !== this.rm.WeightsSetId;
    }
    get saveButtonText(): string { return this.isSaving ? "Saving..." : "Save changes"; }


    handleShowCriterionSelector()
    {
        this.criterionSelectorDialog.show(this.criterionId, this.criteria);
    }

    handleSetCriterion(criterionId: number)
    {
        if (this.goalCriterionId === criterionId)
        {
            this.criterionId = null;
        }
        else
        {
            this.criterionId = criterionId;
        }
    }

    handleCancel()
    {
        this.$router.go(0);
    }

    handleBack()
    {
        this.$router.go(-1);
    }

    handleSave()
    {
        this.isSaving = true;
        this.errors = [];
        this.invokeUpdateWeightedScoreCommandV1(this.workspaceId, this.weightedScoreId, this.weightsSetId, this.criterionId, this.name, this.description);
    }


    mounted()
    {
        document.title = "Edit weighted score";

        if (this.$route.query.attributeId)
        {
            this.runWeightedScoreSettingsByAttributeIdQueryV1(this.workspaceId, this.projectId, Number.parseInt(this.$route.query.attributeId as string));
        }
        else if (this.$route.query.scoreId)
        {
            this.runWeightedScoreSettingsByIdQueryV1(this.workspaceId, this.projectId, Number.parseInt(this.$route.params.evalModelId), this.$route.query.scoreId as string);
        }
    }

    onSetModel(model: any, modelName: string)
    {
        if (modelName === "WeightedScoreSettingsReadModel")
        {
            this.rm = model as WeightedScoreSettingsReadModel;

            this.name = this.rm.Name;
            this.description = this.rm.Description;
            this.weightsSetId = this.rm.WeightsSetId;
            this.criterionId = this.rm.CriterionId;

            this.initialized = true;
        }
    }

    onCommandSucceed(cmd: ICriteriaCommand, correlationId: string, result: any)
    {
        if (UpdateWeightedScoreCommandV1.matchType(cmd))
        {
            this.$router.go(0);
        }
    }

    onCommandFailed(status: ICommandStatus)
    {
        if (UpdateWeightedScoreCommandV1.matchType(status.Command))
        {
            this.errors = status.ValidationErrors;
            this.isSaving = false;
        }
    }

    beforeRouteLeave(to: any, from: any, next: (arg?: any) => void) 
    {
        if (this.hasChanges === true && this.isSaving === false) 
        {
            if (confirm("You have unsaved changes. Do you want to save them before leaving?")) 
            {
                this.handleSave();
                next();
            }
            else 
            {
                next();
            }
        }
        else 
        {
            next();
        }
    }
}
